<template>
  <div class="flex flex-col">
    <FormPayment
      v-if="selectedInvoice?.doc_number"
      :doc_number="selectedInvoice.doc_number"
      :amount_open="selectedInvoice.amount_open"
      @payment="paymentAdded"
    />
    <TableDocs
      v-else
      type="Facture"
      api-type="invoices"
      number-prefix="FA"
      payment-status
      add-payment
      @pay="selectedInvoice = $event"
    />
  </div>
</template>

<script>
import FormPayment from '@/components/Form/Payment'
import TableDocs from '@/components/Table/Docs'
import { ref } from 'vue'

export default {
  components: {
    FormPayment,
    TableDocs,
  },
  theme() {
    return {
      title: 'Factures',
      buttons: [
        {
          to: '/invoices/add',
          label: '+ Ajouter facture',
        },
      ],
    }
  },
  setup() {
    const selectedInvoice = ref(null)
    const paymentAdded = payment => {
      selectedInvoice.value.open_amount -= payment.amount
      selectedInvoice.value = null
    }
    return { selectedInvoice, paymentAdded }
  },
}
</script>

<style></style>
